import { render, staticRenderFns } from "./MasterProposalCp.vue?vue&type=template&id=804d271c&scoped=true&"
import script from "./MasterProposalCp.vue?vue&type=script&lang=js&"
export * from "./MasterProposalCp.vue?vue&type=script&lang=js&"
import style0 from "./MasterProposalCp.vue?vue&type=style&index=0&id=804d271c&prod&lang=css&"
import style1 from "./MasterProposalCp.vue?vue&type=style&index=1&id=804d271c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804d271c",
  null
  
)

export default component.exports